import React from "react";
import { useTranslation } from "react-i18next";
import AccordionBox from "components/Layouts/AccordionBox";
import SimpleDataTable from "components/Modules/SimpleDataTable";

const CheckedOutServices = ({ customCaptions, servicesList, isLoading }) => {
	const { t } = useTranslation();
	return (
		<AccordionBox
			title={t("label.mobileEntity", {
				entity: customCaptions?.userPlural ?? "Users",
			})}
			accordianDetailsCss="siteDetailTableContainer"
		>
			<SimpleDataTable
				isLoading={isLoading}
				data={servicesList}
				tableHeaders={[
					`${customCaptions?.serviceWorkOrder}` || "Work Order",
					`${customCaptions?.model}` || `Model Name`,
					`${customCaptions?.asset}` || `Asset Name`,
					`${customCaptions?.interval}` || `Interval`,
					`${customCaptions?.role}` || `Role`,
					`${customCaptions?.user ?? "User"}`,
					t("label.date"),
				]}
			/>
		</AccordionBox>
	);
};

export default CheckedOutServices;
